/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  OrganizationUsage,
  OrganizationUsageCollections,
  OrganizationUsageMembers,
  OrganizationUsageSites,
  OrganizationUsageSpaces,
  OrganizationUsageTeamMembers,
  OrganizationUsageTeams,
} from "./data-contracts";

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetUsageForOrganizationById
 * @summary Get all usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage
 * @secure
 */

// @ts-ignore
export const getUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationUsage;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetCollectionsUsageForOrganizationById
 * @summary Get collections usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/collections
 * @secure
 */

// @ts-ignore
export const getCollectionsUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Collections usage metrics of an organization */
    collections: OrganizationUsageCollections;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/collections",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetSpacesUsageForOrganizationById
 * @summary Get spaces usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/spaces
 * @secure
 */

// @ts-ignore
export const getSpacesUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Spaces usage metrics of an organization */
    spaces: OrganizationUsageSpaces;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/spaces",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetSitesUsageForOrganizationById
 * @summary Get sites usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/sites
 * @secure
 */

// @ts-ignore
export const getSitesUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Sites usage metrics of an organization */
    sites: OrganizationUsageSites;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/sites",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetTeamsUsageForOrganizationById
 * @summary Get teams usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/teams
 * @secure
 */

// @ts-ignore
export const getTeamsUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Team members usage metrics of an organization */
    teams: OrganizationUsageTeams;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/teams",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetMembersUsageForOrganizationById
 * @summary Get members usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/members
 * @secure
 */

// @ts-ignore
export const getMembersUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Members usage metrics of an organization */
    members: OrganizationUsageMembers;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/members",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organizations-usage, usage, internal
 * @name GetTeamMembersUsageForOrganizationById
 * @summary Get team members usage metrics for an organization
 * @request GET:/orgs/{organizationId}/usage/team-members
 * @secure
 */

// @ts-ignore
export const getTeamMembersUsageForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Team members usage metrics of an organization */
    teamMembers: OrganizationUsageTeamMembers;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/usage/team-members",
  method: "get",
  streaming: false,
  tags: ["organizations-usage", "usage", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};
